import { render } from "./S168267.vue?vue&type=template&id=3d30a525"
const script = {}
script.render = render

export default script